export const createImages = (resourcePath) => ({
    INTO: resourcePath + 'images/into.svg',

    ERROR_FORBIDDEN: resourcePath + 'images/error/forbidden.svg',

    COMMON_MODAL_BACK: resourcePath + 'images/common/modal/base_back.svg',
    COMMON_MODAL_ERROR: resourcePath + 'images/common/modal/base_error.svg',
    COMMON_MODAL_LOADING: resourcePath + 'images/common/modal/base_loading.svg',
    COMMON_MODAL_ICON_XMARK: resourcePath + 'images/common/modal/icon_xmark.svg',

    COMMON_ICON_IMG_MASK: resourcePath + 'images/common/icon/img_mask.svg',

    COMMON_ICON_TABLE_ACTION_LINK: resourcePath + 'images/common/table_action/base_link.svg',
    COMMON_ICON_TABLE_ACTION_INFO: resourcePath + 'images/common/table_action/base_info.svg',
    COMMON_ICON_TABLE_ACTION_UPDATE: resourcePath + 'images/common/table_action/base_update.svg',
    COMMON_ICON_TABLE_ACTION_DELETE: resourcePath + 'images/common/table_action/base_delete.svg',
    COMMON_ICON_TABLE_ACTION_PUBLISH: resourcePath + 'images/common/icon/publish_green.svg',
    COMMON_ICON_TABLE_ACTION_DOC_VIEW: resourcePath + 'images/common/table_action/doc_view.svg',
    COMMON_ICON_TABLE_ACTION_DOC_CANCEL: resourcePath + 'images/common/table_action/doc_cancel.svg',
    COMMON_ICON_TABLE_ACTION_DOC_REJECT: resourcePath + 'images/common/table_action/doc_reject.svg',
    COMMON_ICON_TABLE_ACTION_DOC_DOWNLOAD: resourcePath + 'images/common/table_action/doc_download.svg',
    COMMON_ICON_TABLE_ACTION_DOC_CONVERT: resourcePath + 'images/common/table_action/doc_convert.svg',
    COMMON_ICON_TABLE_ACTION_APPROVE: resourcePath + 'images/common/table_action/doc_approve.svg',
    COMMON_ICON_TABLE_ACTION_SEAL_APPROVE: resourcePath + 'images/common/table_action/doc_seal_approve.svg',
    COMMON_ICON_TABLE_ACTION_SEAL: resourcePath + 'images/common/table_action/doc_seal.svg',

    COMMON_ICON_IMG_GUIDE: resourcePath + 'images/common/img_crop/preview_guide.svg',
    COMMON_ICON_IMG_CROP: resourcePath + 'images/common/img_crop/crop.svg',
    COMMON_ICON_IMG_CROP_ZOOM: resourcePath + 'images/common/img_crop/crop_zoom.svg',
    COMMON_ICON_IMG_CROP_ROTATE: resourcePath + 'images/common/img_crop/crop_rotate.svg',
    COMMON_ICON_IMG_CROP_CONTRACT: resourcePath + 'images/common/img_crop/crop_contract.svg',
    COMMON_ICON_IMG_CROP_ZOOM_PLUS: resourcePath + 'images/common/img_crop/crop_zoom_plus.svg',
    COMMON_ICON_IMG_CROP_ZOOM_MINUS: resourcePath + 'images/common/img_crop/crop_zoom_minus.svg',
    COMMON_ICON_IMG_CROP_ROTATE_LEFT: resourcePath + 'images/common/img_crop/crop_rotate_left.svg',
    COMMON_ICON_IMG_CROP_ROTATE_RIGHT: resourcePath + 'images/common/img_crop/crop_rotate_right.svg',
    COMMON_ICON_IMG_CROP_VERTICAL: resourcePath + 'images/common/img_crop/crop_flip_vertical.svg',
    COMMON_ICON_IMG_CROP_HORIZONTAL: resourcePath + 'images/common/img_crop/crop_flip_horizontal.svg',

    COMMON_ICON_TREE_FOLDER_CLOSED: resourcePath + 'images/common/tree/folder_closed.svg',
    COMMON_ICON_TREE_FOLDER_OPENED: resourcePath + 'images/common/tree/folder_opened.svg',

    COMMON_ICON_ARROW_UP_FONT6: resourcePath + 'images/common/icon/arrow_up_font6.svg',
    COMMON_ICON_ARROW_DOWN_FONT6: resourcePath + 'images/common/icon/arrow_down_font6.svg',
    COMMON_ICON_PLUS_FONT6: resourcePath + 'images/common/icon/plus_font6.svg',
    COMMON_ICON_PLUS_PRIMARY: resourcePath + 'images/common/icon/plus_primary.svg',
    COMMON_ICON_PLUS_WHITE: resourcePath + 'images/common/icon/plus_white.svg',
    COMMON_ICON_DOWNLOAD_GREEN: resourcePath + 'images/common/icon/download_green.svg',
    COMMON_ICON_DOWNLOAD_PRIMARY: resourcePath + 'images/common/icon/download_primary.svg',
    COMMON_ICON_XLSX_DOWNLOAD_WHITE: resourcePath + 'images/common/icon/xlsx_download_white.svg',
    COMMON_ICON_MORE_FONT2: resourcePath + 'images/common/icon/more_font2.svg',
    COMMON_ICON_MOVE_FONT6: resourcePath + 'images/common/icon/move_font6.svg',
    COMMON_ICON_MINUS_FONT6: resourcePath + 'images/common/icon/minus_font6.svg',
    COMMON_ICON_VIEW_PRIMARY: resourcePath + 'images/common/icon/view_primary.svg',
    COMMON_ICON_VIEW_FONT2: resourcePath + 'images/common/icon/view_font2.svg',
    COMMON_ICON_COPY_FONT2: resourcePath + 'images/common/icon/copy_font2.svg',
    COMMON_ICON_COPY_FONT7: resourcePath + 'images/common/icon/copy_font7.svg',
    COMMON_ICON_UPLOAD_PRIMARY: resourcePath + 'images/common/icon/upload_primary.svg',
    COMMON_ICON_UPLOAD_INIT_FONT6: resourcePath + 'images/common/icon/upload_init_font6.svg',

    PAGE_BASE_MENU_EXPAND: resourcePath + 'images/page/base/menu_expand.svg',
    PAGE_BASE_MENU_COLLAPSE: resourcePath + 'images/page/base/menu_collapse.svg',
    PAGE_BASE_MODAL_LOGOUT: resourcePath + 'images/page/base/modal_logout.svg',
    PAGE_BASE_BG_EMPTY_CARD: resourcePath + 'images/page/base/bg_empty_card.svg',
    PAGE_BASE_ICON_FAVORITE: resourcePath + 'images/page/base/icon_favorite.svg',

    PAGE_USER_INFO_ICON_USER_INFO_BASIC: resourcePath + 'images/page/user_info/icon_user_info_basic.svg',
    PAGE_USER_INFO_ICON_USER_INFO_PERSONAL: resourcePath + 'images/page/user_info/icon_user_info_personal.svg',

    DESIGN_USER_DOCUMENT_DRAFT_PUBLISH: resourcePath + 'images/design/user_document_draft/publish.svg',
    DESIGN_USER_DOCUMENT_DRAFT_SAVE_FILE: resourcePath + 'images/design/user_document_draft/file_save.svg',
    DESIGN_USER_DOCUMENT_DRAFT_CHANGE_FILE: resourcePath + 'images/design/user_document_draft/file_change.svg',
    DESIGN_USER_DOCUMENT_DRAFT_FIELD_ORDER_UP: resourcePath + 'images/design/user_document_draft/field_order_up.svg',
    DESIGN_USER_DOCUMENT_DRAFT_FIELD_ORDER_DOWN: resourcePath + 'images/design/user_document_draft/field_order_down.svg',
    DESIGN_USER_DOCUMENT_DRAFT_FIELD_ORDER_TOP: resourcePath + 'images/design/user_document_draft/field_order_top.svg',
    DESIGN_USER_DOCUMENT_DRAFT_FIELD_ORDER_BOTTOM: resourcePath + 'images/design/user_document_draft/field_order_bottom.svg',

    PUBLISH_USER_DOCUMENT_DRAFT_ICON_PUBLISH: resourcePath + 'images/publish/user_document_draft/icon_publish.svg',
    PUBLISH_USER_DOCUMENT_DRAFT_ICON_ARROW_NEXT: resourcePath + 'images/publish/user_document_draft/icon_arrow_next.svg',
    PUBLISH_USER_DOCUMENT_DRAFT_ICON_DOC_BASIC: resourcePath + 'images/publish/user_document_draft/icon_doc_basic.svg',
    PUBLISH_USER_DOCUMENT_DRAFT_ICON_DOC_OPTION: resourcePath + 'images/publish/user_document_draft/icon_doc_option.svg',
    PUBLISH_USER_DOCUMENT_DRAFT_ICON_DOC_APPROVER: resourcePath + 'images/publish/user_document_draft/icon_doc_approver.svg',
    PUBLISH_USER_DOCUMENT_DRAFT_ICON_DOC_SEAL_APPROVER: resourcePath + 'images/publish/user_document_draft/icon_doc_seal_approver.svg',
    PUBLISH_USER_DOCUMENT_DRAFT_ICON_DOC_SEALER: resourcePath + 'images/publish/user_document_draft/icon_doc_sealer.svg',
    PUBLISH_USER_DOCUMENT_DRAFT_ICON_DOC_ATTACHMENT: resourcePath + 'images/publish/user_document_draft/icon_doc_attachment.svg',
    PUBLISH_USER_DOCUMENT_DRAFT_ICON_DOC_VIEW_PASSWORD: resourcePath + 'images/publish/user_document_draft/icon_doc_view_password.svg',

    FLOW_USER_DETAIL_DOCUMENT_ICON_RELOAD: resourcePath + 'images/flow/user_detail_doc/icon_reload.svg',
    FLOW_USER_DETAIL_DOCUMENT_ICON_VIEW: resourcePath + 'images/flow/user_detail_doc/icon_view.svg',
    FLOW_USER_DETAIL_DOCUMENT_ICON_DOWNLOAD: resourcePath + 'images/flow/user_detail_doc/icon_download.svg',
    FLOW_USER_DETAIL_DOCUMENT_ICON_RECONVERT: resourcePath + 'images/flow/user_detail_doc/icon_reconvert.svg',
    FLOW_USER_DETAIL_DOCUMENT_ICON_EXTRACT_DATA: resourcePath + 'images/flow/user_detail_doc/icon_extract_data.svg',

    ICON_COMMON_GRIP: resourcePath + 'images/common/icon/move_font6.svg',
    ICON_MINUS_FONT6: resourcePath + 'images/common/icon/minus_font6.svg',

    LOGO: resourcePath + 'images/logo.svg',
});
